import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "./assets/fonts/fonts.css";
/*************Components**************** */
import seo from './components/forms/seo.vue'
import CustomColorPicker from './components/forms/ColorPicker.vue'
import imgeditor from './components/media/editor.vue'
import InternalCropper from './components/media/cropper.vue'
import videoUploader from './components/media/video-uploader.vue'
import navmenu from './components/nav-menu.vue'
import FileUploader from './components/file-uploader.vue'
import NonImgUploader from './components/non-image-uploader.vue'
/*************Library Components******** */
import { Cropper } from 'vue-advanced-cropper'
import Notifications from 'vue-notification'
import JsonExcel from 'vue-json-excel'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
/*************************************** */
import VImageInput from 'vuetify-image-input';
import EleUploadVideo from "vue-ele-upload-video";
import FlagIcon from 'vue-flag-icon';
import LanguagesDropdown from 'vue-languages-dropdown'
import VueCurrencyInput from 'vue-currency-input'
import VueQuillEditor from 'vue-quill-editor'
 
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
 
Vue.use(VueQuillEditor, /* { default global options } */)
Vue.use(FlagIcon);
Vue.prototype.lang = "fa";
const pluginOptions = {
  /* see config reference */
  globalOptions: { currency: 'IRR', locale:"fa" }
}

Vue.config.productionTip = false;
Vue.component('languages-dropdown',LanguagesDropdown);
Vue.component('date-picker', VuePersianDatetimePicker);
Vue.component("seo-form",seo);
Vue.component("custom-picker",CustomColorPicker);
Vue.component("nav-menu",navmenu);
Vue.component("file-upload",NonImgUploader);
Vue.component("imgeditor",imgeditor);
Vue.component("videouploader",videoUploader);
Vue.component("image-cropper",InternalCropper);
Vue.component("f-up",FileUploader);
Vue.component(VueCurrencyInput);
Vue.component(Cropper);
Vue.component(JsonExcel);
Vue.use(Notifications);
Vue.component(VImageInput.name, VImageInput);
Vue.component(EleUploadVideo.name, EleUploadVideo);
const lang = "fa";
new Vue({
  data:{lang},
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
